module.exports = __webpack_public_path__ + "ebf0b65f1a580d72467eed4d88e7b2e6.svg";